import React, { useEffect, useCallback } from 'react';
import noop from 'lodash/noop';
import get from 'lodash/get';
import { Input, Modal, message } from 'antd';
import { NEW_SHARING_DASHBOARD_NAME } from '@store/dashboards/tabs/utils/constants';
import { deleteSharedTab } from '@store/sharedTabs';
import { useDispatch } from 'react-redux';

const DashboardPrompt = ({
  tabsStore,
  dashboardsUIStore,
  createDashboard,
  updateDashboard,
  initCreating,
  initUpdating,
  changeSaveDashboardPromptVisibility,
  isLoading,
  hasError,
  okText,
  cancelText,
}) => {
  const { savePromptVisibility, activeDashboardId } = dashboardsUIStore;
  const { tabsData = {} } = tabsStore;
  const activePayload = tabsData[activeDashboardId]
    || tabsData[`${NEW_SHARING_DASHBOARD_NAME}${activeDashboardId}`]
    || {};

  useEffect(() => {
    if (!savePromptVisibility) {
      initCreating();
      initUpdating();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savePromptVisibility]);

  const dispatch = useDispatch();
  const inputRef = React.useRef(null);
  const onSave = useCallback(() => {
    const name = get(inputRef, 'current.input.value');
    if (!name) {
      message.error('Please enter dashboard name.');
      return;
    }
    const {
      id,
      config,
      dashboardTypeId,
      unsaved,
    } = activePayload;
    const payload = {
      name,
      config,
      dashboardTypeId,
      isSaved: true,
    };
    if (unsaved) {
      createDashboard(payload, id);
      dispatch(deleteSharedTab(id, false));
    } else {
      updateDashboard(payload, id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePayload]);

  const onCancel = () => {
    changeSaveDashboardPromptVisibility(false, null);
  };

  return (
    (<Modal
      key={activePayload.id}
      title={!activePayload.unsaved ? 'Update Dashboard' : 'Create Dashboard'}
      open={savePromptVisibility}
      onOk={onSave}
      confirmLoading={!hasError && isLoading}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
    >
      <Input
        name="dashboard-name"
        placeholder="Enter dashboard name"
        defaultValue={activePayload.name}
        ref={inputRef}
        autocomplete="off"
      />
    </Modal>)
  );
};

DashboardPrompt.defaultProps = {
  tabsStore: {},
  dashboardsUIStore: {},
  createDashboard: noop,
  updateDashboard: noop,
  changeSaveDashboardPromptVisibility: noop,
  isLoading: false,
  hasError: false,
  okText: 'Save',
  cancelText: 'Cancel',
};

export default DashboardPrompt;
